import { invertedScores } from "../../InSilicoPredictions/scoresBasedInsilicoPredictions/helpers/getThresholds";

function transformThresholds(inputElement) {
  if (!inputElement) return undefined;

  // Check if input element is an array. If so, it means that the new thresholds
  // are given as an argument and we transform the thresholds back to the old type {object}
  if (typeof inputElement === "object" && inputElement?.length) {
    return inputElement
      .map(({ name, pathogenic_supporting, benign_supporting }) => ({
        name: name.toLowerCase().replace("-", "_"),
        benign: benign_supporting.threshold,
        pathogenic: pathogenic_supporting.threshold,
        inverted: invertedScores.includes(
          name.toLocaleLowerCase().replace("-", "_")
        ),
      }))
      .reduce(
        (acc, { benign, pathogenic, inverted, name }) => ({
          ...acc,
          [`${name}_benign`]: benign,
          [`${name}_pathogenic`]: pathogenic,
          [`${name}_inverted`]: inverted,
        }),
        {}
      );
  }
  // If the inputElement is not an array we return the thresholds as they are
  return inputElement;
}

export { transformThresholds };
